import React from "react";
import CustomerDetailsField from "./customerField";
import withStyles from "@material-ui/core/styles/withStyles";
import { useStyles } from "../indexFormStyles";

function AddressDetailsForm({ form }) {
  return (
    <>
      <CustomerDetailsField label={"Pincode"} value={form.pincode} />
      <CustomerDetailsField label={"City"} value={form.city} />
      <CustomerDetailsField label={"State"} value={form.state} />
      <CustomerDetailsField label={"Address"} value={form.address} />
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(AddressDetailsForm);
